import SeverityBadge from 'components/feedback/SeverityBadge';
import VehicleCard from 'components/feedback/VehicleCard';

import MRMBadge from './MRMBadge';
import styles from './styles/VehicleDeviationCard.module.scss';
import type { PrioritezedItem } from './types';

interface Props {
    vehicle: PrioritezedItem;
    isSelected: boolean;
    mrmState?: PrioritezedItem['mrmState'] | null;
    onClick: () => void;
    vehicleIdentifier: string;
    className?: string;
    connectivityState?: PrioritezedItem['connectivityState'];
}

const VehicleDeviationCard = ({
    vehicle,
    vehicleIdentifier,
    isSelected,
    onClick,
    className,
    mrmState,
    connectivityState,
}: Props) => (
    <VehicleCard
        className={className}
        isSelected={isSelected}
        severity={vehicle.severity}
        relativeTime={vehicle.relativeTime}
        vehicleIdentifier={vehicleIdentifier}
        onClick={onClick}
        connectivityState={connectivityState}
        icon={
            <div className={`${styles.VehicleDeviationCard__badge} display-flex align-items-center gap-5`}>
                {!!mrmState && <MRMBadge mrmState={mrmState} />}
                <SeverityBadge severity={vehicle.severity} />
            </div>
        }
    />
);

export default VehicleDeviationCard;
